import React from "react";
import { SessionsProps } from "../interfaces/Session";
import ReadMoreComponent from "./ReadMore";

// Update the prop type to expect an array of sessions

const Sessions: React.FC<SessionsProps> = ({ sessionData }) => {
  return (
    <div
      style={{ backgroundImage: `url("./images/bg-2.png")` }}
      className="bg-cover bg-no-repeat pt-2"
    >
      <div className="container mx-auto my-8 relative items-center justify-center py-12">
        <h4 className="text-center text-lg text-[#037897] capitalize mb-4">
          online session
        </h4>
        <h2 className="text-center font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide	mb-10">
          Knowledge in Motion, Wellness Online
        </h2>

        {sessionData.map((session) => (
          <div className="rounded-lg shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] m-4 mb-6">
            <div className="flex flex-col md:flex-row  p-4">
              <div className="basis-full md:basis-2/12 md:border-r text-center border-[#C2C2C2]">
                <span className="text-4xl font-bold text-[#037897]">
                  {new Date(session.startDate ?? "").toLocaleDateString(
                    "en-US",
                    { day: "numeric" }
                  )}
                </span>
                <p className="text-xl font-semibold">
                  {" "}
                  {new Date(session.startDate ?? "").toLocaleDateString(
                    "en-US",
                    { month: "long" }
                  )}
                </p>
              </div>
              <div className="basis-full md:basis-7/12 flex flex-col md:flex-row  px-4 pl-6 py-2 justify-center border-t  border-b md:border-0">
                <h3 className="text-xl basis-4/12 pr-2 font-semibold pt-3 md:pt-0">
                  {session.title}
                </h3>
                <p className="text-[#546E7A] basis-8/12 pr-4 ">
                  <ReadMoreComponent
                    text={session?.description ?? ""}
                    maxLength={120}
                  />
                </p>
              </div>
              <div className="basis-full md:basis-3/12 md:border-l text-center border-[#C2C2C2] p-4 flex  items-center justify-center">
                <p className="text-xl font-semibold">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    className="inline mr-4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M27 14C27 21.1802 21.1802 27 14 27C6.81978 27 1 21.1802 1 14C1 6.81978 6.81978 1 14 1C21.1802 1 27 6.81978 27 14Z"
                      stroke="#037897"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M18.8218 18.1351L13.5234 14.9744V8.16235"
                      stroke="#037897"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  {new Date(session.startTime ?? "").toLocaleTimeString(
                    "en-US",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  to{" "}
                  {new Date(session.endTime ?? "").toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Sessions; // Correct export statement
